import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const MonthlyRevenueChart = ({ data }) => {
  const PRODUCT_LABELS = {
    "practical training": "Farm Training",
    "physical site inspection": "Physical Site Inspection",
    "hydroponic masterclass": "Hydroponic Masterclass",
    allother: "Allother",
    "site inspection kit": "Site Inspection Kit",
    "aif project report": "Aif Project Report",
  };

  const revenueValues = Object.values(data);
  const originalLabels = Object.keys(data);

  const labels = originalLabels.map((label) => PRODUCT_LABELS[label] || label);

  // Define unique colors per product
  const colorMap = {
    "hydroponic masterclass": "#6F95D4",
    "physical site inspection": "#85D46F",
    allother: "rgba(153, 102, 255, 0.5)",
    "site inspection kit": "#D4786F",
    "practical training": "#D4A06F",
    "aif project report": "#CFD486",
  };

  const backgroundColors = originalLabels.map(
    (label) => colorMap[label] || "#888"
  );

  const chartData = {
    labels,
    datasets: [
      {
        label: "Monthly Revenue (₹)",
        data: revenueValues,
        backgroundColor: backgroundColors,
        borderColor: backgroundColors,
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) =>
            `${context.label}: ₹ ${context.raw.toLocaleString()}`,
        },
      },
    },
    scales: {
      x: {
        ticks: {
          autoSkip: false, // Ensures no skipping of labels
          maxRotation: 0, // Prevents labels from rotating vertically
          minRotation: 0, // Prevents labels from rotating vertically
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value) => `₹${value}`,
        },
      },
    },
  };

  return (
    <div className="card p-4">
      <h3 className="card-title">Monthly Revenue Overview</h3>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default MonthlyRevenueChart;
